// TODO 发布会二维码

export default [
  {
    path: '/conference-qrcode/order',
    name: 'conferenceQRCode',
    component: () => import(/* webpackChunkName: "conferenceQRCode" */ '@/views/conference-qrcode/order.vue')
  },
  {
    path: '/conference-qrcode/change-child',
    name: 'change-child',
    component: () => import(/* webpackChunkName: "change-child" */ '@/views/conference-qrcode/change-child.vue')
  },
  {
    path: '/conference-qrcode/error',
    name: 'conferenceQRCode-error',
    component: () => import(/* webpackChunkName: "conferenceQRCode-error" */ '@/views/conference-qrcode/error.vue')
  }
]
